/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable no-console */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable import/named */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import MaterialTable from 'material-table';
import { Container } from 'reactstrap';
import { useLocation, withRouter } from 'react-router-dom';
import { FaFilePdf } from 'react-icons/fa';
import { RiFileExcel2Fill } from 'react-icons/ri';
import 'jspdf-autotable';
import {
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import logo from '../../shared/img/logo/logo_min.png';
import {
  getrattrapage,
  getsuccess,
  getnotrack,
} from './PDFData';
import excelGen from './Excel/index';
import { excelSheetFromDataSet } from './Excel/DataUtil';
import { Loading } from '../../helpers/utils';
import companyServices from '../../redux/services/companyServices';
import ExamList from './ExamList';
import EditExam from '../Exams/EditExam';
import ExamResults from '../Exams/ExamResults';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  card: {
    border: '0',
    height: '100%',
    width: '97%',
    margin: '20px',
    padding: '20px',
    boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.05), 0 6px 6px rgba(0, 0, 0, 0.05) !important',
    backgroundColor: '#fff',
  },
}));

const JsPDF = typeof window !== 'undefined' ? require('jspdf').jsPDF : null;

const dates = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'];
const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

const FormatDate = ({ date }) => {
  if (date != null) {
    const newDate = new Date(date);
    const formatedDate = `${days[newDate.getDay() === 0 ? newDate.getDay() : newDate.getDay() - 1]} ${newDate.getDate()} ${dates[newDate.getMonth()]}`;
    return <div>{formatedDate}</div>;
  }
  return <div>/</div>;
};

const ExportList = (props) => {
  const { company } = props;
  const [tableData, setTableData] = useState([]);
  const [loaded, setloaded] = useState(false);
  const [examData, setExamData] = useState([]);
  const [editExam, setEditExam] = useState(null);

  const classes = useStyles();

  const handleEditExam = (rowData) => {
    setEditExam(rowData);
  };

  const tableref = React.createRef();

  const getData = async (dataToExport) => {
    const {
      elearningTarget, elearningDuration, elearningAttempts, elearningDurationTarget,
    } = dataToExport.csvnotrack ? dataToExport.csvnotrack.target : {
      elearningTarget: 0, elearningDuration: 0, elearningAttempts: 0, elearningDurationTarget: 0,
    };
    const section = [];

    const exportColumns = ['Nom', 'Email', 'Score quizs', 'Score exercices', 'Temps passé', 'Note (/20)'];
    section.push({ name: 'Réussite', method: await getsuccess(exportColumns, elearningAttempts, elearningTarget, elearningDuration * (elearningDurationTarget / 100) * 60, dataToExport, elearningDurationTarget) });
    section.push({ name: 'En cours', method: await getrattrapage(exportColumns, elearningAttempts, elearningTarget, elearningDuration * (elearningDurationTarget / 100) * 60, dataToExport, elearningDurationTarget) });
    section.push({ name: 'Aucune activité', method: await getnotrack(exportColumns, dataToExport) });
    return section;
  };

  const exportPDFFile = async (dataToExport, semester) => {
    if (JsPDF !== null) {
      const unit = 'pt';
      const size = 'A4';
      const orientation = 'landscape';
      if (!dataToExport.error) {
        const {
          elearningTarget, elearningDuration, elearningAttempts, elearningDurationTarget,
        } = dataToExport.csvnotrack ? dataToExport.csvnotrack.target : {
          elearningTarget: 0, elearningDuration: 0, elearningAttempts: 0, elearningDurationTarget: 0,
        };
        const section = await getData(dataToExport);

        const doc = new JsPDF(orientation, unit, size);
        doc.setFontSize(15);
        const img = new Image();
        img.src = logo;
        doc.addImage(img, 'PNG', 40, 10);
        doc.text(`${props.company.name}, S${semester}`, 130, 45);
        doc.text(`Objectif quizs: ${elearningTarget}%, Objectif exercices: ${elearningAttempts}%, Objectif temps: ${elearningDurationTarget}% de ${elearningDuration / 60}h${(elearningDuration % 60 < 10 ? '0' : '')}${elearningDuration % 60}`, 130, 75);

        section.map((element, index) => {
          if (index === 0) {
            element.method.startY = 115;
            doc.text(element.name, 40, 90);
          } else {
            element.method.startY = 70;
            doc.text(element.name, 40, 45);
          }
          doc.autoTable(element.method);
          if (index + 1 < section.length) doc.addPage();
          return (doc);
        });
        doc.save(`Résultats ${company.name} - Semester ${semester}.pdf`);
      }
    }
  };

  const exportExcel = async (dataToExport, semester) => {
    const {
      elearningTarget, elearningDuration, elearningAttempts, elearningDurationTarget,
    } = dataToExport.csvnotrack ? dataToExport.csvnotrack.target : {
      elearningTarget: 0, elearningDuration: 0, elearningAttempts: 0, elearningDurationTarget: 0,
    };
    if (!dataToExport.error) {
      const wb = { SheetNames: [], Sheets: {} };
      const limitDate = new Date('02/16/2023');
      const exportDate = new Date(dataToExport.exportData.created_at);
      const successdata = limitDate >= exportDate
        ? await excelGen.formatSuccessDataOld(dataToExport, elearningTarget)
        : excelGen.formatSuccessData(
          {
            success: dataToExport.userSuccess,
            rattrapage: dataToExport.userRattrapage,
            notrack: dataToExport.userNoTrackers,
            exportData: dataToExport.exportData,
          },
          elearningDuration * (elearningDurationTarget / 100) * 60,
          elearningTarget,
          elearningAttempts,
          elearningDurationTarget,
        );
      successdata[0].data = successdata[0].data.sort((a, b) => {
        if (a[0].value < b[0].value) { return -1; }
        if (a[0].value > b[0].value) { return 1; }
        return 0;
      });
      wb.SheetNames.push('Succès');
      wb.Sheets['Succès'] = excelSheetFromDataSet(successdata);

      const rattrapdata = limitDate >= exportDate
        ? await excelGen.formatRattrapageDataOld(
          dataToExport, elearningDuration, elearningTarget,
        )
        : excelGen.formatRattrapageData(
          {
            success: dataToExport.userSuccess,
            rattrapage: dataToExport.userRattrapage,
            notrack: dataToExport.userNoTrackers,
            exportData: dataToExport.exportData,
          },
          elearningDuration * (elearningDurationTarget / 100) * 60,
          elearningTarget,
          elearningAttempts,
          elearningDurationTarget,
        );
      rattrapdata[0].data = rattrapdata[0].data.sort((a, b) => {
        if (a[0].value < b[0].value) { return -1; }
        if (a[0].value > b[0].value) { return 1; }
        return 0;
      });
      wb.SheetNames.push('En cours');
      wb.Sheets['En cours'] = excelSheetFromDataSet(rattrapdata);

      const notrackdata = excelGen.formatNoTrackData(dataToExport);
      notrackdata[0].data = notrackdata[0].data.sort((a, b) => {
        if (a[0].value < b[0].value) { return -1; }
        if (a[0].value > b[0].value) { return 1; }
        return 0;
      });
      wb.SheetNames.push('Aucune activité');
      wb.Sheets['Aucune activité'] = excelSheetFromDataSet(notrackdata);

      excelGen.generateExcel(wb, `Résultats Semester ${semester} - ${new Date(dataToExport.exportData.created_at).toLocaleDateString('fr')}.xlsx`);
    }
  };

  const getNbStudents = (results) => {
    let tmpNbStudents = 0;

    tmpNbStudents += results[0].userSuccess.total;
    tmpNbStudents += results[0].userRattrapage.total;
    tmpNbStudents += results[0].userNoTrackers.total;
    tmpNbStudents += results[1].userSuccess.total;
    tmpNbStudents += results[1].userRattrapage.total;
    tmpNbStudents += results[1].userNoTrackers.total;

    return `${tmpNbStudents} étudiants`;
  };

  const loadData = async () => {
    const res = await companyServices.getCompanyExports(company._id);
    const tmp = [];
    res.forEach((element) => {
      const d = new Date('2023-08-30');
      const creation = new Date(element.created_at);
      if (creation.getTime() > d.getTime()) {
        tmp.push(element);
      }
    });
    setTableData(tmp.sort((a, b) => b.created_at > a.created_at));
    setloaded(true);
  };

  useEffect(() => {
    loadData();
  }, []);

  const usePathname = () => {
    const location = useLocation();
    return location.pathname;
  };

  const pathName = usePathname();

  const downloadExport = ({ results, semester, exportData }, opt) => {
    let userNoTrackers = [];
    let userRattrapage = [];
    let userSuccess = [];
    const csvnotrack = { data: [], total: 0 };
    const csvsuccess = { data: [], total: 0 };
    const csvrattrapage = { data: [], total: 0 };

    results.forEach((val) => {
      userNoTrackers = [...userNoTrackers, ...val.userNoTrackers.data];
      userRattrapage = [...userRattrapage, ...val.userRattrapage.data];
      userSuccess = [...userSuccess, ...val.userSuccess.data];
    });
    for (let i = 0; i < userNoTrackers.length; i += 1) {
      for (let j = 0; j < userNoTrackers.length; j += 1) {
        if (userNoTrackers[i] && userNoTrackers[j]._id === userNoTrackers[i]._id && j !== i) {
          userNoTrackers.splice(i, 1);
        }
      }
      for (let j = 0; j < userRattrapage.length; j += 1) {
        if (userNoTrackers[i] && userRattrapage[j]._id === userNoTrackers[i]._id) {
          userNoTrackers.splice(i, 1);
        }
      }
      for (let j = 0; j < userSuccess.length; j += 1) {
        if (userNoTrackers[i] && userSuccess[j]._id === userNoTrackers[i]._id) {
          userNoTrackers.splice(i, 1);
        }
      }
    }
    for (let i = 0; i < userRattrapage.length; i += 1) {
      for (let j = 0; j < userSuccess.length; j += 1) {
        if (userRattrapage[i] && userSuccess[j]._id === userRattrapage[i]._id) {
          userRattrapage.splice(i, 1);
        }
      }
      for (let j = 0; j < userRattrapage.length; j += 1) {
        if (userRattrapage[i] && userRattrapage[j]._id === userRattrapage[i]._id && j !== i) {
          if (userRattrapage[i].percent > userRattrapage[j].percent) { userRattrapage.splice(j, 1); } else if (userRattrapage[j].percent === userRattrapage[i].percent && userRattrapage[i].time > userRattrapage[j].time) { userRattrapage.splice(j, 1); } else { userRattrapage.splice(i, 1); }
        }
      }
    }
    for (let i = 0; i < userSuccess.length; i += 1) {
      for (let j = 0; j < userSuccess.length; j += 1) {
        if (userSuccess[i] && userSuccess[j]._id === userSuccess[i]._id && j !== i) {
          if (userSuccess[i].percent > userSuccess[j].percent) { userSuccess.splice(j, 1); } else if (userSuccess[j].percent === userSuccess[i].percent && userSuccess[i].time > userSuccess[j].time) { userSuccess.splice(j, 1); } else { userSuccess.splice(i, 1); }
        }
      }
    }
    csvnotrack.target = results[0].csvnotrack.target;
    csvrattrapage.target = results[0].csvrattrapage.target;
    csvsuccess.target = results[0].csvsuccess.target;

    csvnotrack.data = userNoTrackers;
    csvnotrack.total = userNoTrackers.length;
    csvrattrapage.data = userRattrapage;
    csvrattrapage.total = userRattrapage.length;
    csvsuccess.data = userSuccess;
    csvsuccess.total = userSuccess.length;
    const dataToExport = ({
      csvnotrack,
      csvsuccess,
      csvrattrapage,
      userSuccess: { data: userSuccess },
      userRattrapage: { data: userRattrapage },
      userNoTrackers: { data: userNoTrackers },
      exportData,
    });
    // eslint-disable-next-line no-constant-condition
    if (opt === true) {
      exportPDFFile(dataToExport, semester);
    } else {
      exportExcel(dataToExport, semester);
    }
  };

  if (loaded) {
    return (
      <Container>
        {editExam !== null
          ? (
            <Grid className={classes.card} container>
              <EditExam editExam={editExam} setEditExam={(data) => handleEditExam(data)} />
            </Grid>
          )
          : null}
        <MaterialTable
          title="Exports"
          columns={[
            {
              title: 'Date',
              field: 'created_at',
              render: ({ created_at }) => <FormatDate date={created_at} />,
            },
            {
              title: 'Semestre',
              field: 'semester',
            },
            {
              title: 'Rattrapage',
              field: 'catchUp',
              render: (rowData) => {
                if (rowData.catchUp && rowData.catchUp === true) {
                  return 'Oui';
                }
                return '-';
              },
            },
            {
              title: 'Nombre d\'étudiants',
              field: 'results',
              render: ({ results }) => getNbStudents(results),
            }]}
          tableRef={tableref}
          data={tableData}
          options={{
            actionsColumnIndex: -1,
            pageSize: 3,
          }}
          localization={{
            header: {
              actions: 'Exports',
            },
            toolbar: {
              exportCSVName: 'Exporter en Excel',
              exportPDFName: 'Exporter en PDF',
            },
            body: {
              emptyDataSourceMessage: 'Aucun export.',
            },
          }}
          actions={[
            {
              icon: () => <FaFilePdf color="red" />,
              tooltip: 'Telecharger l\'export PDF',
              onClick: (_event, exportData) => downloadExport({ results: exportData.results, semester: exportData.semester, exportData }, true),
            },
            {
              icon: () => <RiFileExcel2Fill color="#228822" />,
              tooltip: 'Telecharger l\'export Excel',
              onClick: (_event, exportData) => downloadExport({ results: exportData.results, semester: exportData.semester, exportData }, false),
            },
          ]}
        />
        <div style={{ height: '50px' }} />
        {
            (() => {
              switch (pathName) {
                case '/list':
                  return (
                    <ExamList
                      examData={examData}
                      setExamData={setExamData}
                      handleEditExam={(rowData) => handleEditExam(rowData)}
                    />
                  );
                case '/results':
                  return <ExamResults redirectPath={`/company/exports/${company._id}`} />;
                default:
                  return (
                    <ExamList
                      examData={examData}
                      setExamData={setExamData}
                      handleEditExam={(rowData) => handleEditExam(rowData)}
                    />
                  );
              }
            })()
          }
        <div style={{ height: '50px' }} />
      </Container>
    );
  }
  return (<Loading />);
};

function mapState(state) {
  const { company } = state.company;
  const { auth } = state.authentication;
  return { company, auth };
}

const actionCreators = {};

const connectedExportList = connect(mapState, actionCreators)(ExportList);

export default withRouter(connectedExportList);
